module.exports = __webpack_public_path__ + "img/daffodil-screeningforcancer.7386563e.png";